<template>
    <div class="t-lk-leads-view">
        <div class="t-lk-container">
            <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>
            <div v-if="info" v-animation:bottom.delay class="t-lk-leads-view__container">
                <div class="t-lk-leads-view__row">
                    <div v-if="info.img" class="t-lk-leads-view__img">
                        <img :src="info.img" :alt="info.name">
                    </div>
                    <div class="t-lk-leads-view__date">{{ info.date }}</div>
                    <div class="t-lk-leads-work__buttons">
                        <!-- Принять -->
                        <div
                            v-if="info && info.status === 0"
                            class="t-lk-leads-work__btn t-btn _green _lk"
                            @click.prevent.stop="handleAcceptLead"
                        >
                            {{ $root.staticText.lk.leadsWorkBtn }}
                        </div>
                        <!-- Отказаться -->
                        <div
                            v-if="info && info.status === 0"
                            class="t-lk-leads-work__btn t-btn _border-gray _lk"
                            @click.prevent.stop="handleCloseLead"
                        >
                            {{ $root.staticText.lk.leadsWorkBtn2 }}
                        </div>
                    </div>

                    <div v-if="info.status === 1" class="t-lk-leads-view-status js-status">
                      <div class="t-lk-leads-view-status__head">
                        <lk-date-lead-cmp
                          is-btn
                          :item="info"
                          @change:date="handleChangeDate"
                        ></lk-date-lead-cmp>
                        <div
                          class="t-lk-leads-view-status__change-status-btn"
                          :class="{_open: openChangeBlock}"
                          @click="openChangeBlock = !openChangeBlock"
                        >
                          {{ $root.staticText.lk.leadsWorkBtn4 }}
                          <svg class="t-lk-leads-view-status__arrow" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.7949 12.1053C4.05528 12.3656 4.47744 12.3656 4.73782 12.1053L8.93359 7.90948L13.1294 12.1053C13.3897 12.3656 13.8119 12.3656 14.0723 12.1053C14.3327 11.8449 14.3327 11.4227 14.0723 11.1623L9.40505 6.49509C9.14467 6.23471 8.72251 6.23471 8.46213 6.49509L3.7949 11.1623C3.53451 11.4227 3.53451 11.8449 3.7949 12.1053Z" fill="#00b0bd"/>
                          </svg>
                        </div>
                      </div>

                        <transition name="fade">
                            <div v-if="openChangeBlock" class="t-lk-leads-view-status__container">
                                <!-- Выиграл -->
                                <div
                                    class="t-lk-leads-view-status__item"
                                    @click.prevent.stop="changeStatusAndShowDate()"
                                >
                                    {{ $root.staticText.lk.leadsStatus5 }}
                                </div>
                                <!-- В работе -->
                                <!-- <div
                                    class="t-lk-leads-view-status__item"
                                    @click.prevent.stop="changeStatus(1)"
                                >
                                    {{ $root.staticText.lk.leadsStatus4 }}
                                </div> -->
                                <!-- Сделка не состоялась -->
                                <div
                                    class="t-lk-leads-view-status__item"
                                    @click.prevent.stop="handleChangeStatus(3)"
                                >
                                    {{ $root.staticText.lk.leadsStatus6 }}
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="t-lk-leads-view__name">{{ info.name }}</div>
                <div class="t-lk-leads-view__wrap">
                    <div v-if="info.list.length" class="t-lk-leads-view__item">
                        <div class="t-lk-leads-view__subtitle">{{ $root.staticText.lk.leadsViewSubtitle }}</div>
                        <div
                            class="t-lk-main-leads__row"
                            v-for="item in info.list"
                        >
                                <div class="t-lk-main-leads__subtitle">{{ item.name }}</div>
                                <div class="t-lk-main-leads__value">{{ item.value }}</div>
                        </div>

                        <div v-if="info && info.status === 0" class="t-lk-leads-work__status">
                            {{ $root.staticText.lk.leadsStatusText + ' ' }}
                            <span>{{ timer(info.timer, false) }}</span>
                        </div>

                        <div v-else-if="(info.status === 1 && info.timer.day === 0 && info.dateDeal) || (info.status === 2)" class="t-lk-main-leads__row">
                            <div class="t-lk-main-leads__subtitle _bold">{{ $root.staticText.lk.leadsStatus3 }}</div>
                            <div class="t-lk-main-leads__value _bold" @click.stop.prevent="">
                                <template v-if="info.timer.day > 0 && info.status !== 2 || (info.status === 2 && !info.noConfirm)">{{ info.dateDeal }}</template>
                                <lk-date-lead-cmp 
                                    v-else-if="info.timer.day === 0 || (info.status === 2 && info.noConfirm)"
                                    ref="date-view" 
                                    :item="info"
                                    @set-status="setStatus"
                                    @change:date="handleChangeDate"
                                ></lk-date-lead-cmp>
                            </div>
                        </div>

                        <div v-else-if="info && info.status === 1" class="t-lk-leads-work__status">
                            {{ $root.staticText.lk.leadsStatus2 + ' ' + $root.staticText.lk.leadsWorkTimer + ' ' }}
                            {{ timer(info.timer, true) }}
                        </div>

                        <div
                            v-if="info.file && Object.keys(info.file).length"
                            class="t-lk-leads-view__attachment"
                        >
                            <p class="t-lk-leads-view__attachment-title">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="16px" width="16px" version="1.1" id="Layer_1" viewBox="0 0 280.067 280.067" xml:space="preserve">
                                    <g>
                                        <path fill="currentColor" d="M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429   c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0   s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394   c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599   c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403   c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485   c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098   l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"/>
                                    </g>
                                </svg>
                                Вложения:
                            </p>
                            <a
                                class="t-lk-leads-view__attachment-link"
                                :href="info.file.path"
                                download
                            >
                                {{ info.file.name }}
                            </a>
                        </div>
                    </div>

                    <div v-if="info.details.length && info.status !== 0" class="t-lk-leads-view__item">
                        <div class="t-lk-leads-view__subtitle">{{ $root.staticText.lk.leadsViewSubtitle2 }}</div>
                        <div class="t-lk-main-leads__row" v-for="item in info.details">
                            <div class="t-lk-main-leads__subtitle">{{ item.name }}</div>
                            <div class="t-lk-main-leads__value">{{ item.value }}</div>
                        </div>
                    </div>
                    <div v-if="info.status === 0" class="t-lk-leads-view__item">
                        <div class="t-lk-leads-view__subtitle">{{ $root.staticText.lk.leadsViewNoStatus }}</div>
                    </div>
                </div>
            </div>

            <!-- <h2
                v-if="contacts && contacts.length && info && info.status !== 0"
                v-animation:bottom.delay
                class="t-lk-title t-lk-leads-view-contact__title t-lk-container-mobile"
            >
                {{ $root.staticText.lk.leadsViewTitle }}
            </h2>
            <div v-if="contacts && info && info.status !== 0" class="t-lk-leads-view-contact">
                <div v-if="contacts.length" v-for="item in contacts" v-animation:bottom.delay class="t-lk-leads-view-contact__item">
                    <div v-if="item.img" class="t-lk-leads-view-contact__img">
                        <img :src="item.img" :alt="item.name">
                    </div>
                    <div class="t-lk-leads-view-contact__content">
                        <div class="t-lk-leads-view-contact__name">
                            {{ item.name }}
                            <div
                                v-if="info.status === 1 && item.permission[0] === 'delete'"
                                class="t-lk-leads-view-contact__delete"
                                @click="modalType_deleteContactOpen({
                                    leadId: info.id,
                                    contactId: item.id
                                })"
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33301 5.83333H16.6663M15.833 5.83333L15.1105 15.9517C15.0806 16.3722 14.8924 16.7657 14.5839 17.053C14.2755 17.3403 13.8696 17.5 13.448 17.5H6.55134C6.12979 17.5 5.7239 17.3403 5.41541 17.053C5.10693 16.7657 4.91877 16.3722 4.88884 15.9517L4.16634 5.83333H15.833ZM8.33301 9.16667V14.1667V9.16667ZM11.6663 9.16667V14.1667V9.16667ZM12.4997 5.83333V3.33333C12.4997 3.11232 12.4119 2.90036 12.2556 2.74408C12.0993 2.5878 11.8874 2.5 11.6663 2.5H8.33301C8.11199 2.5 7.90003 2.5878 7.74375 2.74408C7.58747 2.90036 7.49967 3.11232 7.49967 3.33333V5.83333H12.4997Z" stroke="#D65663" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <a :href="'mailto' + item.email" class="t-lk-leads-view-contact__email t-link-hover">
                            {{ item.email }}
                        </a>
                    </div>
                </div>
                <div
                    v-if="info && info.status === 1"
                    v-animation:bottom.delay
                    class="t-lk-leads-view-contact__item _last"
                    @click="modalType_attachContactOpen({
                        optionsContacts: optionsContacts,
                        leadId: info.id,
                        attachHandler: updateLeadPageData

                    })"
                >
                    {{ $root.staticText.lk.leadsViewText }}
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import lkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs.vue';
    import { mapActions, mapGetters } from "vuex";
    import {router} from "@src/routes";
    import lkDate from '@components/lk/lk-date-lead/lk-date-lead.vue';

    export default {
        name: "lk-leads-view",
        data() {
            return {
                breadcrumbs: null,
                info: null,
                optionsContacts: [],
                reasons: [],
                contacts: [],
                openChangeBlock: false,
                timerId: null
            }
        },
        components: {
            'lk-breadcrumbs-cmp': lkBreadcrumbs,
            'lk-date-lead-cmp': lkDate,

        },
        computed: {
            ...mapGetters('lk', ['leadDealNone', 'leads']),
        },
        watch: {
            'leadDealNone': function () {
                if (this.leadDealNone) {
                    this.info.status = 3;
                }
            },
        },
        methods: {
            ...mapActions('modal', [
                'modalType_lkSuccessOpen',
                'modalType_lkErrorOpen',
                'modalClose',
                'modalType_attachContactOpen',
                'modalType_deleteContactOpen',
                'modalType_refuseLeadOpen',
                'modalType_changeDateOpen',
                'modalType_lkAcceptLeadModal'
            ]),
            ...mapActions('lk/leads', {
                getLeadPageData: 'getLeadPage',
                acceptLead: 'acceptLead',
                closeLead: 'closeLead',
                changeLeadStatus: 'changeStatus',
                changeLeadDate: 'changeDate',
                openWinLeadModal: 'openWinLeadModal',
            }),

            timer(timer, typeMass) {
                let keyDay = "day";
                let keyHour = "hour";
                let keyMinute = "minute";
                if (typeMass) {
                    keyDay = "day2";
                    keyHour = "hour2";
                    keyMinute = "minute2";
                }
                let day = timer.day + ' ' + this.$root.num2str(timer.day, this.$root.staticText.lk[keyDay]);

                if (timer.day > 1) {
                    return day;
                } else {
                    // запускаем таймер один раз
                    if (!this.timerId) {
                        this.timerId = setInterval(() => {
                            if (timer.minute === 0) {
                                if (timer.hour === 0) {
                                    if (timer.day === 0) {
                                        clearInterval(this.timerId);
                                        // запрос на обновление данных
                                        this.updateLeadPageData();
                                    } else {
                                        if (timer.day !== 0) {
                                            // this.setItemLeadsTimer({index: index, name: 'hour', value: 23});
                                            timer.hour = 23;
                                            timer.minute = 59;
                                        }
                                        // this.setItemLeadsTimer({index: index, name: 'day', value: timer.day - 1});
                                        timer.day = timer.day - 1;
                                    }

                                } else {
                                    if (timer.day !== 0 || timer.hour !== 0) {
                                        // this.setItemLeadsTimer({index: index, name: 'minute', value: 59});
                                        timer.minute = 59;
                                    }
                                    // this.setItemLeadsTimer({index: index, name: 'hour', value: timer.hour - 1});
                                    timer.hour = timer.hour - 1;
                                }

                            } else {
                                // this.setItemLeadsTimer({index: index, name: 'minute', value: timer.minute - 1});
                                timer.minute = timer.minute - 1;

                                if (timer.minute === 0 && timer.hour === 0 && timer.day === 0) {
                                    clearInterval(this.timerId);
                                    // запрос на обновление данных
                                    this.updateLeadPageData();
                                }
                            }
                        }, 60000);
                    }

                    day = timer.day + ' ' + this.$root.num2str(timer.day, this.$root.staticText.lk[keyDay]);
                    let hour = timer.hour + ' ' + this.$root.num2str(timer.hour, this.$root.staticText.lk[keyHour]);
                    let minute = timer.minute + ' ' + this.$root.num2str(timer.minute, this.$root.staticText.lk[keyMinute]);

                    return (timer.day === 0) ?
                        (timer.hour === 0) ? minute : hour + ' ' + minute :
                        day + ' ' + hour + ' ' + minute;
                }
            },

            async updateLeadPageData () {
                const { data } = await this.getLeadPageData();

                this.breadcrumbs = data.breadcrumbs;
                this.info = data.info;
                this.optionsContacts = data.optionsContacts;
                this.reasons = data.reasons;
                this.contacts = data.contacts;
            },
            changeStatusAndShowDate() {
                this.openWinLeadModal({
                    item: this.info,
                    winLeadHandler: this.updateLeadPageData
                });
                // this.info.status = 2
                // Vue.set(this.info, 'noConfirm', true)
            
                // this.$nextTick(() => {
                //     this.$refs['date-view'].clickDate()
                // })
            },

            setStatus() {
                this.info.status = 1
            },

            async handleChangeStatus(status, date) {
                this.openChangeBlock = false;

                if (status === this.info.status && status !== 2) return;
                
                // если сделака не состоялась
                if (status === 3) {
                    this.modalType_refuseLeadOpen({
                        reasons: this.reasons,
                        status,
                        leadId: this.info.id,
                        overflowNone: true,
                        refuseHandler: this.updateLeadPageData
                    });
                    return;
                }

                const { success } = await this.changeLeadStatus({
                    id: this.info.id,
                    status,
                    date
                })

                if (!success) return;

                await this.updateLeadPageData();
            },
            async handleAcceptLead () {
                this.modalType_lkAcceptLeadModal({
                    leadId: this.info.id,
                    acceptLeadHandler: this.updateLeadPageData
                })
            },
            async handleCloseLead () {
                const { success } = await this.closeLead(this.info.id);

                if (!success) return;

                this.$router.push({
                    name: 'lk-leads'
                })
            },
            async handleChangeDate ({ date }) {
                // оставил кусок когда, пока что не знаю для чего нужен флаг noComfirm
                if (this.info.noConfirm) {
                    // меняем статус на двояк + дата
                    // переиспользуем уже реализованный метод
                    await this.handleChangeStatus(2, date);
                    return;
                }

                // открываем модалку с коментом при каждой смене даты
                this.modalType_changeDateOpen({
                    leadId: this.info.id,
                    date,
                    changeDateHandler: this.updateLeadPageData,
                });
            },
            clickOutside() {
                if (!event.target.closest('.js-status')) {
                    this.openChangeBlock = false;
                }
            },
        },
        async mounted () {
            await this.updateLeadPageData();
            document.addEventListener('click', this.clickOutside)
        },
        beforeDestroy() {
            clearInterval(this.timerId);
            document.removeEventListener('click', this.clickOutside);
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/leads/view/index.vue